<template>
    <div class="form">
        <Tabs v-if="showProgress" :animated="false" v-model="active">
            <TabPane label="基本信息" :index="1" name="basic"></TabPane>
            <TabPane label="进度情况" :index="2" name="progress"></TabPane>
        </Tabs>
        <div :class="showProgress? 'form-order-content-box' : ''">
            <Form
                v-if="active == 'basic'"
                ref="info"
                :model="info"
                :rules="ruleValidate"
                :label-width="100"
            >
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem :label="dataSource + '号'" prop="orderNo">
                            <Input disabled v-model="info.orderNo" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="服务类别" prop="serviceType">
                            <Select
                                v-model="info.serviceType"
                                readonly
                                transfer
                                clearable
                                placeholder
                            >
                                <Option
                                    v-for="(item, index) in serviceTypeList"
                                    :value="item.id"
                                    :key="index"
                                >{{item.text}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="业务类别" prop="busType">
                            <Select
                                v-model="busType"
                                :readonly="readonly || !canUpdate('busType')"
                                transfer
                                clearable
                                placeholder
                                multiple
                            >
                                <Option
                                    v-for="(item, index) in busTypeList"
                                    :value="item.id"
                                    :key="index"
                                >{{item.text}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="要求完成时间" prop="planCompleteTime">
                            <DatePicker
                                v-model="planCompleteTime"
                                :readonly="readonly || !canUpdate('planCompleteTime')"
                                transfer
                                style="width: 100%"
                                type="datetime"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="需求描述" prop="description">
                            <Input
                                type="textarea"
                                v-model="info.description"
                                :readonly="readonly || !canUpdate('description')"
                                placeholder
                                :rows="2"
                                :maxlength="1000"
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="相关图片" prop="attachments">
                            <preview-upload
                                v-model="info.attachments"
                                :readonly="readonly || !canUpdate('attachments')"
                                :format="imgSuffix"
                            ></preview-upload>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="实施地址" prop="addr">
                            <Input
                                v-model="info.addr"
                                :readonly="readonly || !canUpdate('addr')"
                                :maxlength="256"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20" v-if="info.orderDataSource == 'G'">
                    <Col span="12">
                        <FormItem label="联系人" prop="contactName">
                            <Input
                                v-model="info.contactName"
                                :readonly="readonly || !canUpdate('contactName')"
                                :maxlength="256"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="contactPhone">
                            <Input
                                v-model="info.contactPhone"
                                :readonly="readonly || !canUpdate('contactPhone')"
                                :maxlength="256"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="指派人" prop="assignUserId">
                            <form-lookup
                                v-model="info.assignUserId"
                                readonly
                                placeholder
                                title="选择领导人员"
                                textSymbol="nickname"
                                :modalHeight="540"
                                :modalWidth="800"
                                :options.sync="assignOptions"
                            >
                                <select-inside></select-inside>
                            </form-lookup>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="指派时间" prop="assginTime">
                            <DatePicker
                                v-model="assginTime"
                                readonly
                                transfer
                                style="width: 100%"
                                type="datetime"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="执行人" prop="execUserId">
                            <form-lookup
                                v-model="info.execUserId"
                                :readonly="readonly || !canUpdate('execUserId')"
                                placeholder
                                title="选择执行人员"
                                textSymbol="nickname"
                                :modalHeight="540"
                                :modalWidth="800"
                                :options.sync="execOptions"
                            >
                                <select-inside></select-inside>
                            </form-lookup>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="执行电话" prop="execUserPhone">
                            <Input
                                v-model="info.execUserPhone"
                                readonly
                                :maxlength="256"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem :label="dataSource + '状态'" prop="orderStatus">
                            <Select
                                v-model="info.orderStatus"
                                readonly
                                transfer
                                clearable
                                placeholder
                            >
                                <Option
                                    v-for="(item, index) in orderStatusList"
                                    :value="item.id"
                                    :key="index"
                                >{{item.text}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="完成时间" prop="realCompleteTime">
                            <DatePicker
                                v-model="realCompleteTime"
                                readonly
                                transfer
                                style="width: 100%"
                                type="datetime"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="验收时间" prop="acceptTime">
                            <DatePicker
                                v-model="acceptTime"
                                readonly
                                transfer
                                style="width: 100%"
                                type="datetime"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="服务打分" prop="score">
                            <Rate
                                show-text
                                :disabled="readonly || !canUpdate('score')"
                                v-model="info.score"
                            >
                                <span :style="{color: variables.linkColor}">{{ info.scoreText }}</span>
                            </Rate>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem
                            :label="info.orderDataSource == 'G'? '报单人' : '下达人'"
                            prop="createUserName"
                        >
                            <Input
                                v-model="info.createUserName"
                                disabled
                                :maxlength="256"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="info.orderDataSource == 'G'? '报单时间' : '下达时间'"
                            prop="createTime"
                        >
                            <DatePicker
                                v-model="createTime"
                                disabled
                                transfer
                                style="width: 100%"
                                type="datetime"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <Steps v-else :current="progressCurrent" direction="vertical">
                <Step
                    v-for="(item, index) in progress"
                    :key="index"
                    :title="item.text"
                    :icon="index <= progressCurrent? '_yiwanchengbuzhou' : (index == progressCurrent + 1 ? '_dangqianbuzhou' : '_weiwanchengbuzhou')"
                    :iconColor="index == progressCurrent + 1? '#ffb720' : ''"
                >
                    <div slot="content">
                        <p class="form-order-progress-time">{{item.createTime | ymdL}}</p>
                        <span
                            class="form-order-progress-title"
                        >{{item.execType == 3 ? "打回理由: ": (item._isEvaluate ? "验收评价: ":"")}}</span>
                        <span style="white-space: pre-wrap;">{{item.content}}</span>
                        <preview-upload v-model="item.attachments" readonly></preview-upload>
                        <span class="form-order-progress-title" v-if="item._isEvaluate">服务打分:</span>
                        <Rate v-if="item._isEvaluate" show-text disabled v-model="item.score">
                            <span :style="{color: variables.linkColor}">{{ item.scoreText }}</span>
                        </Rate>
                    </div>
                </Step>
            </Steps>
        </div>
    </div>
</template>
<script>
import { Steps, Step } from 'ivux'
import dayjs from 'dayjs'
import { tel } from '_u/validate'
import { orderDetails, orderAdd, orderUpdate } from '@/api/order-manage'
import SelectInside from '_vc/select-inside'
import PreviewUpload from '_c/preview-upload'
import Dict from '_u/dict'
import Enum from '_u/enum'
import { ymdL, toDate } from '_u/helper'
import { Rate } from 'ivux'

const STEPS = Enum.get('STEPS')
const SIMPLE_STEPS = Enum.get('SIMPLE_STEPS')
const SCORE_LEVEL = Enum.get('SCORE_LEVEL')

export default {
    name: 'FormOrderWaitInfo',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {
        PreviewUpload,
        SelectInside,
        Rate,
        Steps,
        Step
    },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            active: 'basic',
            progressCurrent: 0,
            imgSuffix: this.$config.upload.imgSuffix,
            info: {
                id: this.id,
                orderNo: '', // 工单号
                orderDataSource: '', // 工单|任务
                serviceType: '', // 服务类别
                busType: '', // 业务类别
                planCompleteTime: '', // 要求完成时间
                description: '', // 需求描述
                attachments: '', // 相关图片
                addr: '', // 实施地址
                contactName: '', // 联系人
                contactPhone: '', // 联系电话
                createTime: '', // 报单时间
                createUserName: '', // 报单人
                assignUserId: '', // 指派人
                assginTime: '', // 指派时间
                execUserId: '', // 执行人
                execUserPhone: '', // 执行电话
                orderStatus: '', //工单状态
                realCompleteTime: '', //完成时间
                acceptTime: '', // 验收时间
                score: 0, // 服务打分
                scoreText: '', // 打分说明
                ver: '' // 版本号
            },
            progress: [],
            updateKeys: [
                'id',
                'serviceType', // 服务类别
                'busType', // 业务类别
                'planCompleteTime', // 要求完成时间
                'description', // 需求描述
                'attachments', // 相关图片
                'addr', // 实施地址
                'contactName', // 联系人
                'contactPhone', // 联系电话
                'orderStatus', //工单状态
                'ver' // 版本号
            ],
            dict: {
                serviceType: Dict.NULL,
                busType: Dict.NULL,
                orderStatus: Dict.NULL
            },
            canSave: true,
            assignOptions: [],
            execOptions: []
        }
    },

    computed: {
        readonly() {
            return !this.canSave || this.loading
        },
        showProgress() {
            let statusArr = ['3', '5', '6']
            return statusArr.includes(this.info.orderStatus)
        },
        dataSource() {
            return this.info.orderDataSource == 'G' ? '工单' : '任务'
        },
        ruleValidate() {
            return {
                orderNo: [
                    { required: true, message: `${this.dataSource}号必填` }
                ],
                contactPhone: [{ validator: tel }],
                execUserPhone: [{ validator: tel }]
            }
        },

        planCompleteTime: {
            get() {
                return this.info.planCompleteTime
                    ? toDate(this.info.planCompleteTime)
                    : ''
            },
            set(val) {
                this.info.planCompleteTime = ymdL(val)
            }
        },
        realCompleteTime: {
            get() {
                return this.info.realCompleteTime
                    ? toDate(this.info.realCompleteTime)
                    : ''
            },
            set(val) {
                this.info.realCompleteTime = ymdL(val)
            }
        },
        createTime: {
            get() {
                return this.info.createTime
                    ? toDate(this.info.createTime)
                    : ''
            },
            set(val) {
                this.info.createTime = ymdL(val)
            }
        },
        assginTime: {
            get() {
                return this.info.assginTime
                    ? toDate(this.info.assginTime)
                    : ''
            },
            set(val) {
                this.info.assginTime = ymdL(val)
            }
        },
        acceptTime: {
            get() {
                return this.info.acceptTime
                    ? toDate(this.info.acceptTime)
                    : ''
            },
            set(val) {
                this.info.acceptTime = ymdL(val)
            }
        },
        serviceTypeList() {
            return this.dict.serviceType.val()
        },
        busTypeList() {
            return this.dict.busType.val()
        },

        busType: {
            get() {
                return this.info.busType.split(',').filter(el => el)
            },
            set(el) {
                this.info.busType = el.join(',')
                this.$cache.busType = this.info.busType
            }
        },
        orderStatusList() {
            return this.dict.orderStatus.val()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return orderDetails(this.id)
            } else {
                return Promise.resolve()
            }
        },
        setBtn() {
            // 修改权限 & 未执行
            let canSave =
                this.$can('update') &&
                (this.info.orderStatus == 1 || this.info.orderStatus == 2)
            if (!canSave) {
                this.$modal.updateBtns([
                    { type: 'default', text: '关闭', name: 'cancel' }
                ])
            } else {
                this.$modal.updateBtns([
                    { type: 'primary', text: '确定', name: 'confirm' },
                    { type: 'default', text: '关闭', name: 'cancel' }
                ])
            }
            this.canSave = canSave
        },
        canUpdate(key) {
            return this.updateKeys.includes(key)
        }
    },

    mounted() {
        var $info = this.$refs.info
        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([
                Dict.get(['service_type', 'bus_type', 'order_status']),
                this.fetch()
            ])
                .then(args => {
                    var [dictGroup, view] = args

                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                        // 进度信息
                        let progressList = [],
                            progress = viewData.progress || [],
                            // 打回次数
                            repulseNum =
                                progress.filter(el => el.execType == 3)
                                    .length || 0
                        this.info.scoreText = SCORE_LEVEL.getName(
                            viewData.score
                        )
                        if (
                            viewData.serviceType == 'CG' ||
                            viewData.serviceType == 'YS'
                        ) {
                            progressList = JSON.parse(
                                JSON.stringify(SIMPLE_STEPS.toList())
                            )
                        } else {
                            progressList = JSON.parse(
                                JSON.stringify(STEPS.toList())
                            )
                        }
                        if (repulseNum) {
                            // 有打回操作
                            let repulseItem = progressList.concat([
                                {
                                    text: '打回'
                                }
                            ])
                            for (let i = 0; i < repulseNum; i++) {
                                progressList = JSON.parse(
                                    JSON.stringify(repulseItem)
                                ).concat(progressList)
                            }
                        }
                        if (progressList.length) {
                            progressList.push(
                                { text: '验收评价' },
                                { text: '存档' }
                            )
                        }
                        progress.forEach((el, index) => {
                            if (progressList[index]) {
                                progressList[index].createTime =
                                    el.createTime || ''
                                if (el.execType == 2) {
                                    //跳过操作
                                    progressList[index].content = '暂无'
                                } else {
                                    let simpleSteps = el.serviceType == "CG" || el.serviceType == "YS",
                                    evaluateIndex = simpleSteps ? 3 : 7
                                    progressList[index]._isEvaluate = el.execType == 1 && el.step == evaluateIndex
                                    progressList[index].content =
                                        el.content || ''
                                }
                                progressList[index].attachments =
                                    el.attachments || ''
                                progressList[index].execType = el.execType || ''
                                progressList[index].score = el.score || ''
                                progressList[
                                    index
                                ].scoreText = SCORE_LEVEL.getName(el.score)
                            }
                        })
                        this.progressCurrent = progress.length - 1
                        this.progress = progressList
                        // 指派人
                        if (this.info.assignUserId == 0) {
                            this.info.assignUserId = null
                        }
                        this.assignOptions.push({
                            id: viewData.assignUserId,
                            nickname: viewData.assignUserName
                        })
                        // 执行人
                        if (this.info.execUserId == 0) {
                            this.info.execUserId = null
                        }
                        this.execOptions.push({
                            id: viewData.execUserId,
                            nickname: viewData.execUserName
                        })
                    }
                })
                .finally(() => {
                    this.setBtn()
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    this.$Modal.confirm({
                        title: '修改确认',
                        content: '是否确定修改？',
                        width: 400,
                        onOk: () => {
                            var formData = {}
                            this.updateKeys.forEach(key => {
                                formData[key] = this.info[key]
                            })
                            if (this.id) {
                                orderUpdate(formData)
                                    .then(res => {
                                        this.$Message.success(
                                            this.$t('tips.update.success')
                                        )
                                    })
                                    .catch(err => {
                                        options.closeModal = false
                                    })
                                    .finally(() => {
                                        next()
                                    })
                            } else {
                                orderAdd(formData)
                                    .then(res => {
                                        this.$Message.success(
                                            this.$t('tips.add.success')
                                        )
                                    })
                                    .catch(err => {
                                        options.closeModal = false
                                    })
                                    .finally(() => {
                                        next()
                                    })
                            }
                        },
                        onCancel: () => {
                            options.closeModal = false
                            next()
                        }
                    })
                })
                .catch(() => {
                    options.closeModal = false
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
.form-order {
    &-content-box {
        height: 425px;
        padding-right: 20px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    &-progress-time {
        transform: translateY(-5px);
    }
    &-progress-title {
        color: #aaa;
    }
}
</style>
